import { Component } from '@angular/core';

@Component({
  selector: 'app-alarmsetting',
  templateUrl: './alarmsetting.component.html',
  styleUrls: ['./alarmsetting.component.css']
})
export class AlarmsettingComponent {

}
